/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:28 GMT
 */
const tokens = {
    component: {
        slider: {
            track: {
                height: {
                    value: "2px",
                    type: "dimension",
                },
                backgroundColor: {
                    value: "#D5E3F1",
                    type: "color",
                },
                borderRadius: {
                    value: "2px",
                    type: "dimension",
                },
            },
            thumb: {
                height: {
                    value: "16px",
                    type: "dimension",
                },
                width: {
                    value: "16px",
                    type: "dimension",
                },
                backgroundColor: {
                    value: "#455D82",
                    type: "color",
                },
            },
            progress: {
                backgroundColor: {
                    value: "#455D82",
                    type: "color",
                },
                borderRadius: {
                    value: "2px",
                    type: "dimension",
                },
            },
            label: {
                backgroundColor: {
                    value: "#1e1e1e",
                    type: "color",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
            },
            hover: {
                thumb: {
                    backgroundColor: {
                        value: "#252C44",
                        type: "color",
                    },
                },
                progress: {
                    backgroundColor: {
                        value: "#252C44",
                        type: "color",
                    },
                },
            },
            active: {
                thumb: {
                    backgroundColor: {
                        value: "#252C44",
                        type: "color",
                    },
                },
                progress: {
                    backgroundColor: {
                        value: "#252C44",
                        type: "color",
                    },
                },
            },
            disabled: {
                track: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
                thumb: {
                    backgroundColor: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                },
                progress: {
                    backgroundColor: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                },
            },
        },
    },
};
export default tokens;
